import {
  getInt32,
  getObject,
} from "@surya-digital/leo-ts-types";
import { ProjectSortOrder } from "./projectSortOrder";


export namespace GetArchivedResearcherProjectsSortOrderEnums {
  /* eslint-disable @typescript-eslint/no-shadow */
  export namespace ColumnName {
    export enum ColumnName {
      PROJECT_NAME = "PROJECT_NAME",
      CREATED_ON = "CREATED_ON",
      LAST_MODIFIED = "LAST_MODIFIED",
    }
  
    export interface ColumnNameDTO {
      case: string;
    }
  
    export const fromDTO = (dto: ColumnNameDTO): ColumnName => {
      if (dto === undefined || dto === null) {
        throw new InvalidGetArchivedResearcherProjectsSortOrderColumnNameError(
          `Invalid DTO ${dto} provided for ColumnName.ColumnName`
        );
      }
      switch (dto.case) {
        case "PROJECT_NAME":
          return ColumnName.PROJECT_NAME;
        case "CREATED_ON":
          return ColumnName.CREATED_ON;
        case "LAST_MODIFIED":
          return ColumnName.LAST_MODIFIED;
        default:
          throw new InvalidGetArchivedResearcherProjectsSortOrderColumnNameError(
            `Case ${dto.case} is not valid case of ColumnName.ColumnName`
          );
      }
    };
  
    export const toDTO = (columnName: ColumnName): ColumnNameDTO => {
      const enumDTO = {
        case: ColumnName[columnName],
      };
      return enumDTO;
    };
  }
  
}
export interface GetArchivedResearcherProjectsSortOrderDTO {
  sortIndex: number;
  columnName: GetArchivedResearcherProjectsSortOrderEnums.ColumnName.ColumnNameDTO;
  order: ProjectSortOrder.ProjectSortOrderDTO;
}

export class GetArchivedResearcherProjectsSortOrder {
  readonly isGetArchivedResearcherProjectsSortOrderGetArchivedResearcherProjectsSortOrder: boolean = true;

  readonly sortIndex: number;
  readonly columnName: GetArchivedResearcherProjectsSortOrderEnums.ColumnName.ColumnName;
  readonly order: ProjectSortOrder.ProjectSortOrder;


  constructor(
  sortIndex: number, 
  columnName: GetArchivedResearcherProjectsSortOrderEnums.ColumnName.ColumnName, 
  order: ProjectSortOrder.ProjectSortOrder
  ) {
    this.sortIndex = sortIndex;
    this.columnName = columnName;
    this.order = order;
  }

  static fromDTO(dto: GetArchivedResearcherProjectsSortOrderDTO): GetArchivedResearcherProjectsSortOrder {
    const sortIndex = getInt32(dto, "sortIndex", InvalidGetArchivedResearcherProjectsSortOrderSortIndexError);
    const columnName = GetArchivedResearcherProjectsSortOrderEnums.ColumnName.fromDTO(getObject(dto, "columnName", InvalidGetArchivedResearcherProjectsSortOrderColumnNameError));
    const order = ProjectSortOrder.fromDTO(getObject(dto, "order", InvalidGetArchivedResearcherProjectsSortOrderOrderError));
    return new GetArchivedResearcherProjectsSortOrder(
      sortIndex,
      columnName,
      order
    );
  }

  toDTO(): GetArchivedResearcherProjectsSortOrderDTO {
    const dto: GetArchivedResearcherProjectsSortOrderDTO = {
        sortIndex: this.sortIndex,
        columnName: GetArchivedResearcherProjectsSortOrderEnums.ColumnName.toDTO(this.columnName),
        order: ProjectSortOrder.toDTO(this.order)
    };
    return dto;
  }
  }

GetArchivedResearcherProjectsSortOrder.prototype.toString = function toString(): string {
  return `GetArchivedResearcherProjectsSortOrder(sortIndex='${this.sortIndex}',columnName='${this.columnName}',order='${this.order}')`;
};

export class InvalidGetArchivedResearcherProjectsSortOrderError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedResearcherProjectsSortOrderError";
  }
}
export class InvalidGetArchivedResearcherProjectsSortOrderSortIndexError extends InvalidGetArchivedResearcherProjectsSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedResearcherProjectsSortOrderSortIndexError";
  }
}

export class InvalidGetArchivedResearcherProjectsSortOrderColumnNameError extends InvalidGetArchivedResearcherProjectsSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedResearcherProjectsSortOrderColumnNameError";
  }
}

export class InvalidGetArchivedResearcherProjectsSortOrderColumnNameProjectNameError extends InvalidGetArchivedResearcherProjectsSortOrderColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedResearcherProjectsSortOrderColumnNameProjectNameError";
  }
}

export class InvalidGetArchivedResearcherProjectsSortOrderColumnNameCreatedOnError extends InvalidGetArchivedResearcherProjectsSortOrderColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedResearcherProjectsSortOrderColumnNameCreatedOnError";
  }
}

export class InvalidGetArchivedResearcherProjectsSortOrderColumnNameLastModifiedError extends InvalidGetArchivedResearcherProjectsSortOrderColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedResearcherProjectsSortOrderColumnNameLastModifiedError";
  }
}

export class InvalidGetArchivedResearcherProjectsSortOrderOrderError extends InvalidGetArchivedResearcherProjectsSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedResearcherProjectsSortOrderOrderError";
  }
}
